import React, { useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Chip,
  CircularProgress,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  TextField,
} from "@material-ui/core";
import {
  AssignmentInd,
  AttachMoney,
  Ballot,
  Check,
  CheckCircle,
  Close,
  ExpandLess,
  ExpandMore,
  MonetizationOn,
  PostAdd,
} from "@material-ui/icons";

import TextFieldCustom from "../../components/basic/TextFieldCustom";
import Btn from "../../components/buttons/Btn";
import MaskService from "../../utils/mask/maskService";
import { GridStyled } from "../../styles/GlobalStyle";
import { getDetailContract } from "../../repositories/v1/contract";

function ContractDetail({ row, handleClose }) {
  const [loading, setLoading] = useState(false);
  const [itemsContracts, setItemsContracts] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        const {
          data: { data },
        } = await getDetailContract({ id: row.Id });

        if (Array.isArray(data?.ItensContratos)) {
          setItemsContracts(data?.ItensContratos);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [row.Id]);

  return (
    <Dialog open={!!row?.Id} maxWidth="md" fullWidth onClose={handleClose}>
      <DialogTitle>Detalhes do Contrato</DialogTitle>
      <DialogContent>
        <Grid container alignItems="center" spacing={2}>
          <Grid item md={6} xs={12}>
            <TextFieldCustom
              disabled
              label="CNPJ/CPF"
              type="text"
              value={MaskService.toMask(
                (row?.ClienteCnpj || "").length > 11 ? "cnpj" : "cpf",
                row?.ClienteCnpj || ""
              )}
            />
          </Grid>

          <Grid item md={6} xs={12}>
            <TextFieldCustom
              disabled
              label="Razão"
              type="text"
              value={row?.Empresa?.Razao || ""}
            />
          </Grid>

          <Grid item md={6} xs={12}>
            <TextFieldCustom
              disabled
              label="Tipo"
              type="text"
              value={row?.Tipo || ""}
            />
          </Grid>

          <Grid item md={6} xs={12}>
            <TextFieldCustom
              disabled
              label="Data"
              type="text"
              value={(row?.Data || "").split("-").reverse().join("/")}
            />
          </Grid>

          <Grid item flex={1}>
            {loading && <CircularProgress />}
          </Grid>

          {itemsContracts.map((item) => (
            <GridStyled
              key={item.Id}
              container
              xs={12}
              box-shadow="rgba(104, 104, 146, 0.1) 0px 4px 16px, rgba(105, 105, 155, 0.05) 0px 8px 32px"
              border="1px solid #d3d3d3e2"
              border-radius="5"
              margin="5px 0px 5px 0"
            >
              <Grid item xs={12}>
                <ListContractItem
                  item={item}
                  contractDocument={row.ClienteCnpj}
                />
              </Grid>
            </GridStyled>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        {!loading && <Btn onClick={handleClose} label="Fechar" />}
      </DialogActions>
    </Dialog>
  );
}

const ListContractItem = ({ item, contractDocument }) => (
  <>
    <Accordion defaultExpanded>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel1c-content"
        id="panel1c-header"
      >
        <Grid item container justify="center" alignItems="center">
          <Grid
            item
            xs={item.MotivosCancelamento ? 3 : 12}
            style={{ padding: 10 }}
          >
            <Chip
              label={item.Servico}
              icon={
                item.synced ? (
                  <Check style={{ color: "green" }} />
                ) : (
                  <Close style={{ color: "red" }} />
                )
              }
              style={{
                width: "100%",
              }}
            />
          </Grid>

          {item.MotivosCancelamento && (
            <Grid item xs={9}>
              <TextField
                label="Motivo Cancelamento"
                variant="filled"
                defaultValue={item.DescricaoCancelamento}
                InputProps={{
                  readOnly: true,
                }}
                fullWidth
              />
            </Grid>
          )}
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Grid item xs={12}>
          <List>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <Ballot />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Quantidade" secondary={item.Quantidade} />
            </ListItem>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <AttachMoney />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary="Valor Unitário"
                secondary={item.ValorUnitario}
              />
            </ListItem>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <PostAdd />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary="Valor Unitário Excedente"
                secondary={item.ValorUnitarioExcedente}
              />
            </ListItem>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <MonetizationOn />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Valor Total" secondary={item.ValorTotal} />
            </ListItem>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <AssignmentInd />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={`Utilizador${
                  item.ItemUtilizadorCnpjs.length > 1 ? "es" : ""
                }`}
                secondary={item.ItemUtilizadorCnpjs.map(
                  (utilizador) => utilizador.ClienteCnpj
                ).join(" / ")}
              />
            </ListItem>
            {item.Mapas.length > 0 && (
              <ListMaps
                maps={item.Mapas}
                versions={item.Versoes}
                userDocuments={item.ItemUtilizadorCnpjs.map(
                  (userDocument) => userDocument.ClienteCnpj
                )}
                contractDocument={contractDocument}
              />
            )}
          </List>
        </Grid>
      </AccordionDetails>
    </Accordion>
  </>
);

const ListMaps = ({ maps, versions, userDocuments, contractDocument }) => {
  const [open, setOpen] = useState(true);

  return (
    <>
      <ListItem
        button
        onClick={() => setOpen(!open)}
        style={{ display: "block" }}
      >
        <Grid item style={{ display: "flex" }}>
          <ListItemAvatar>
            <Avatar>
              <CheckCircle />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Mapas"
            secondary={`${maps.length} / ${
              versions.length * userDocuments.length
            }`}
          />
          {open ? <ExpandLess /> : <ExpandMore />}
        </Grid>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {userDocuments.map((userDocument, index) =>
              versions.map((version, versionIndex) => (
                <>
                  <ListItem key={index * versionIndex}>
                    <ListItemIcon>
                      {maps.find(
                        (map) =>
                          map.IdVersao === version.id &&
                          map.ClienteCNPJ === userDocument
                      ) ? (
                        <Check style={{ color: "green" }} />
                      ) : (
                        <Close style={{ color: "red" }} />
                      )}
                    </ListItemIcon>
                    <ListItemText
                      primary={`${version.product} (${version.description})${
                        userDocument !== contractDocument
                          ? ` - Utilizador ${userDocument}`
                          : ""
                      }`}
                    />
                  </ListItem>
                </>
              ))
            )}
          </List>
        </Collapse>
      </ListItem>
    </>
  );
};

export { ContractDetail };
